export default __webpack_public_path__ + "static/media/ecomm.1c4e868a.png";